<template>
  <component :is="onboardingComponent"/>
</template>

<script>
import PromotionDuringOnboardingPopup from '@/base-components/onboarding/PromotionDuringOnboardingPopup';
import DDLogs from '@/DDLogs';
import BenefitsApi from '@/api/BenefitsApi';
import { mapActions, mapState } from 'vuex';
import router from '@/router';
import CreditCardCredentialsOnboarding
  from '@/pages/responsive-pages/authenticated/onboard2/steps/credit-card-connection/CreditCardCredentialsOnboarding';
import StateRouter from '@/pages/responsive-pages/authenticated/routing/StateRouter';
import SecurityInformation
  from '@/pages/responsive-pages/authenticated/onboard2/steps/SecurityInformation';
import PrepareCredentials
  from '@/pages/responsive-pages/authenticated/onboard2/steps/bank-connection/PrepareCredentials';
import BankCredentialsOnboarding
  from '@/pages/responsive-pages/authenticated/onboard2/steps/bank-connection/BankCredentialsOnboarding';
import consts from '../../../../constants/onboarding-state';
import BotiIntro from './steps/BotiIntro.vue';
import YahavIsBack from './steps/YahavIsBack.vue';
import DiscountIncomplete from './DiscountIncomplete.vue';
import ExpenseInvestigationOnboarding from './steps/expense-investigation/ExpenseInvestigationOnboarding.vue';
import ProgressIndication1 from './steps/ProgressIndication1.vue';
import ProgressIndication2 from './steps/ProgressIndication2.vue';
import CashflowIntroInformation from './steps/CashflowIntroInformation.vue';
import ForwardLookingInformation from './steps/ForwardLookingInformation.vue';
import obkPartiallyAuthorized from './ObkPartiallyAuthorized';
import MetricApi from '../../../../api/MetricsApi';
import OnBoardingFlowWrapper from '../navigation-pages/month-review/OnBoardingFlowWrapper';
import IncomeInvestigationOnboarding from './steps/income-investigation/IncomeInvestigationOnboarding';
import OshBalanceInformation from './steps/OshBalanceInformation';
import PreparingCashflow from './steps/PreparingCashflow';

export default {
  name: 'OnboardFlow',
  components: {
    PromotionDuringOnboardingPopup,
  },
  async created() {
    this.addTrustedSiteScript();
    await this.handleOnboardingState();
    if (this.$route.query && this.$route.query.promoCode && this.$route.query.returning) {
      const { promoCode } = this.$route.query;
      await this.fetchPromotion(promoCode);
      await BenefitsApi.createBenefitByPromoCode(promoCode);
      this.openModal({
        component: PromotionDuringOnboardingPopup,
      });
    }
  },
  computed: {
    ...mapState('session', ['customerId']),
    ...mapState('onboardingState', ['pageName', 'isLoading', 'error', 'pageParams']),
    ...mapState('websocket', ['socketMessage']),
    pageToComponent() {
      return {
        [consts.ONBOARDING_PAGE.BOTI_INTRO]: BotiIntro,
        [consts.ONBOARDING_PAGE.YAHAV_IS_BACK]: YahavIsBack,
        [consts.ONBOARDING_PAGE.PROGRESS_INDICATION_1]: ProgressIndication1,
        // TODO: delete this line and the ProgressIndication2 component
        [consts.ONBOARDING_PAGE.PROGRESS_INDICATION_2]: ProgressIndication2,
        [consts.ONBOARDING_PAGE.PREPARING_CASHFLOW]: PreparingCashflow,
        [consts.ONBOARDING_PAGE.CASHFLOW_INTRO_INFORMATION]: CashflowIntroInformation,
        [consts.ONBOARDING_PAGE.PAST_MONTH]: OnBoardingFlowWrapper,
        [consts.ONBOARDING_PAGE.FORWARD_LOOKING_INFORMATION]: ForwardLookingInformation,
        [consts.ONBOARDING_PAGE.OSH_BALANCE_INFORMATION]: OshBalanceInformation,
        [consts.ONBOARDING_PAGE.SECURITY_INFORMATION]: SecurityInformation,
        [consts.ONBOARDING_PAGE.PREPARE_CREDENTIALS]: PrepareCredentials,
        [consts.ONBOARDING_PAGE.BANK_DETAILS]: BankCredentialsOnboarding,
        [consts.ONBOARDING_PAGE.OBK_PARTIALLY_AUTHORIZED]: obkPartiallyAuthorized,
        [consts.ONBOARDING_PAGE.DISCOUNT_INCOMPLETE]: DiscountIncomplete,
        [consts.ONBOARDING_PAGE.INCOME_INVESTIGATION]: IncomeInvestigationOnboarding,
        [consts.ONBOARDING_PAGE.CREDIT_CARD_DETAILS]: CreditCardCredentialsOnboarding,
        [consts.ONBOARDING_PAGE.EXPENSE_INVESTIGATION]: ExpenseInvestigationOnboarding,
        [consts.ONBOARDING_PAGE.CASHFLOW]: StateRouter, // This is just in case the user gets here after he finished OB
      };
    },
    onboardingComponent() {
      return this.pageToComponent[this.pageName];
    },
  },
  methods: {
    ...mapActions('promotions', ['fetchPromotion']),
    ...mapActions('onboardingState', ['fetchOnboardingStateIfFinishedLoading', 'handleOnboardingState']),
    ...mapActions('modalRootStore', ['openModal']),
    addTrustedSiteScript() {
      const tag = document.createElement('script');
      tag.setAttribute('src', 'https://cdn.ywxi.net/js/1.js');
      document.head.appendChild(tag);
    },
  },
  watch: {
    pageName(newValue) {
      MetricApi.sendCounter('onboarding.page.entered', { page: newValue });
    },
    async socketMessage(newValue, oldValue) {
      DDLogs.log(`Socket message changed from  ${oldValue} to ${newValue}, is loading = ${this.isLoading}`,
        {
          oldValue,
          newValue,
          loading: this.isLoading,
        });
      if (newValue !== oldValue) {
        if (this.isLoading) {
          await this.fetchOnboardingStateIfFinishedLoading();
          if (this.pageName === consts.ONBOARDING_PAGE.CASHFLOW) {
            router.push({ path: '/sr' });
          }
        }
      }
    },
  },
};
</script>
